import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Try to get theme from localStorage, default to 'light'
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        // Validate saved theme, default to 'light' if invalid
        return ['light', 'dark', 'island'].includes(savedTheme) ? savedTheme : 'light';
    });

    // Update localStorage and body class when theme changes
    useEffect(() => {
        localStorage.setItem('theme', theme);
        // Clear previous theme classes
        document.body.className = ''; 
        // Add the current theme class if it's not light
        if (theme !== 'light') {
            document.body.classList.add(`${theme}-theme`);
        }
    }, [theme]);

    // Cycle through themes: light -> dark -> island -> light
    const toggleTheme = () => {
        setTheme(prevTheme => {
            if (prevTheme === 'light') return 'dark';
            if (prevTheme === 'dark') return 'island';
            return 'light'; // Default back to light from island
        });
    };

    // Function to set a specific theme directly
    const setSpecificTheme = (newTheme) => {
        if (['light', 'dark', 'island'].includes(newTheme)) {
            setTheme(newTheme);
        } else {
            // Default to 'light' if the theme name is invalid
            console.warn(`Invalid theme specified: ${newTheme}. Defaulting to 'light'.`);
            setTheme('light');
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, setSpecificTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
